import React from "react";
import RoutePointManagementTable from "./RoutePointManagementTable";

const RoutePointManagement = () => {

  return <div>{<RoutePointManagementTable />}</div>;
};

export default RoutePointManagement;
